<div style="overflow-y: auto">
    @for (notification of notifications(); track notification.notificationId) {
        <app-notification [notification]="notification" (read)="readNotification($event)"></app-notification>
    } @empty {
        <p-message severity="info" icon="fa fa-info-circle">Nessuna notifica</p-message>
    }
</div>
<div class="flex justify-content-end mt-3">
    <app-action-button type="confirm" label="Segna tutte come lette"
                       [loading]="isReadingAll"
                       [disabled]="notifications().length == 0"
                       (click)="readAllNotifications()"
    ></app-action-button>
</div>
